import { IImageDrawableObject } from "../../../../../../domain/editableFormat/objects";
import { IImageDrawableObjectBean } from "../../../beans/objects";
import { AbstractObjectTranslator } from "../AbstractObjectTranslator";
import { QuoteBehaviorTranslator } from "../properties";
import { RectangleCoordinatableObjectTranslator } from "./RectangleCoordinatableObjectTranslator";

export class ImageDrawableObjectTranslator<TObject extends IImageDrawableObject, TBean extends IImageDrawableObjectBean> extends AbstractObjectTranslator<TObject, TBean> {
  constructor() {
    super(new RectangleCoordinatableObjectTranslator());
  }

  overwriteObject(source: TObject, bean: TBean, formatId: number): void {
    source.quoteBehavior = this.quoteBehavior.from(bean);
    source.formatId = formatId;
    source.imageContent = {
      isEnable: !!bean["@path"],
      guid: bean["@path"],
    };
    source.temporaryImageContent = {
      isEnable: false,
      guid: null,
    };
  }

  overwriteBean(source: TBean, object: TObject): void {
    source["@quote"] = this.quoteBehavior.to(object).quote;
    source["@path"] = object.temporaryImageContent.isEnable
      ? object.temporaryImageContent.guid
      : object.imageContent.isEnable
        ? object.imageContent.guid
        : undefined;
  }

  private readonly quoteBehavior = new QuoteBehaviorTranslator();
}
